import TablestoreListOrders from "../components/table-store-list-orders";
import BignumbersPedidos from "../components/big-numbers-pedidos";
import { Grid } from "@material-ui/core";
import LoadingData from "components/Loading/LoadingData";

export default function PedidosView({
  showCardPedidos,
  cancelLoading,
  storeListOrders,
  pesquisandoPedidos,
  periodoPedidosLabel,
  handleSearchOrders,
  _cnpj,
  itemXSBigNumbersPedidos,
  handleStopSearching,
}) {
  return (
    <>
      {storeListOrders && showCardPedidos && (
        <Grid item xs={12}>
          <BignumbersPedidos
            data={storeListOrders}
            isMobile={itemXSBigNumbersPedidos}
          />
        </Grid>
      )}
      {showCardPedidos &&
        !cancelLoading &&
        storeListOrders &&
        !pesquisandoPedidos && (
          <TablestoreListOrders
            dataTable={storeListOrders}
            labelDias={periodoPedidosLabel}
            search={handleSearchOrders}
            cnpj={_cnpj}
          />
        )}
      {pesquisandoPedidos && (
        <Grid item xs={12}>
          <LoadingData
            searching={pesquisandoPedidos}
            onClick={() => handleStopSearching()}
            label="Buscando Títulos..."
          />
        </Grid>
      )}
    </>
  );
}
